import { Component, Input } from "@angular/core";
import { QuestionTickerSize, QuestionTickerState } from "src/app/interfaces/question";

@Component({
  selector: 'question-ticker',
  templateUrl: './ticker.component.html',
  styleUrls: ['./ticker.component.scss']
})
export class QuestionTickerComponent {
  constructor() {

  }

  @Input() size: QuestionTickerSize = 'small';
  @Input() state: QuestionTickerState = 'normal';
  @Input() image: string | undefined;
  @Input() name = '';
  @Input() showToggleIcon = false;
  @Input() backgroundColor: string | undefined;


}